export default {
  namespaced: true,

  state: {
    isVisible: false,
    text: '',
    color: '',
  },

  mutations: {
    SHOW_NOTIFICATION(state, data) {
      state.color = data.color;
      state.text = data.text;
      state.isVisible = true;
    },

    HIDE_NOTIFICATION(state) {
      state.isVisible = false;
    },
  },
};
